import { cva } from 'class-variance-authority';

const avatarVariants = cva(
  'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-pill font-sans select-none',
  {
    variants: {
      'tone': {
        'placeholder': 'bg-surface-avatar text-text-secondary',
        'accent': 'bg-accent-tint text-accent',
      },
      'size': {
        '32': 'text-caption-sm-semibold size-8',
        '36': 'text-control-semibold size-9',
        '56': 'text-title-card size-14',
      },
    },
    defaultVariants: {
      tone: 'placeholder',
      size: '32',
    },
  },
);

export {
  avatarVariants,
};
